<div class="bg-surface-100 text fixed top-0 left-0 z-997 flex h-16 w-full items-center px-7">
  <div class="flex w-78 items-center">
    <p-button class="mr-2 inline-flex items-center justify-center" icon="fas fa-bars" (click)="toggleSideBar()" [disabled]="!userAuthenticated"  />
    <a class="inline-flex items-center gap-2 text-2xl font-medium" routerLink="/">
      <img src="./assets/logo.png" />
      <span>{{title}}</span>
    </a>
  </div>

  <div class="ml-auto flex items-center justify-center gap-4">
    <div class="flex gap-4">
      <p-button [icon]="isDark ? 'far fa-sun' : 'far fa-moon'"
                variant="outlined"
                (click)="changeTheme()">
      </p-button>

      <p-splitbutton icon="far fa-user" [model]="userLinks" />
    </div>
  </div>
</div>
